import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const BathSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$bathSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$bathSection' });

  return (
    <section id="hp-bath" className="hp-section bath-section bath">
      <div
        className="hp-banner desktop-only"
        data-event-name="bloc_interact"
        data-bloc-name={t('title')}
      >
        <Link href={tLink('bath')} className="clearfix reverse">
          <div className="stack left color-bg">
            <h2>
              {t('title')}
              <span>{t('titleSpan')}</span>
            </h2>
            <p className="desktop-only">{t('copy')}</p>
            <span className="btn base-btn btn-main white">
              <span>{tButton('shopNow')}</span>
            </span>
          </div>
          <div className="ctg-image">
            <picture>
              <source
                data-srcset="/images/homepage/bathSection/LEM-Bath-mob.jpg"
                media="(max-width: 768px)"
                srcSet="/images/homepage/bathSection/LEM-Bath-mob.jpg"
              />
              <img
                data-src="/images/homepage/bathSection/LEM-Bath.jpg"
                alt={t('alt')}
                src="/images/homepage/bathSection/LEM-Bath.jpg"
                loading="lazy"
                decoding="async"
                fetchPriority="low"
                width="960"
                height="750"
              />
            </picture>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default BathSection;
